<template>
  <v-app-bar class="pt-1" elevation="1">
    <v-container>
      <v-row class="align-center flex-nowrap justify-center">
        <v-col cols="auto" class="align-self-center">
          <v-app-bar-title>Bonk!</v-app-bar-title>
        </v-col>
        <v-col md="6">
          <v-combobox
            label="Park name"
            v-model="remoteName"
            density="compact"
            hide-details
            :items="remoteNames"
          />
        </v-col>
        <v-col cols="auto">
          <v-btn
            icon="mdi-refresh"
            border @click="reloadNames"
            :loading="loadingNames"
            title="Refresh selected park informations"
          />
        </v-col>
        <v-col cols="auto">
          <v-btn
            class="bg-black"
            variant="elevated"
            prepend-icon="mdi-console-line"
            rounded="xl"
            @click="submitStartBonk"
            :loading="loadingBonk"
          >BONK!
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-app-bar>
  <XTerm class="my-2" @connected="stopLoading" @not-connected="stopLoading" :wsurl="wsUrl"/>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import XTerm from "../components/XTerm.vue";
import { getBonknames, startBonk } from "../remote/bonk.js";

const route = useRoute();

const remoteName = ref(null);
const wsUrl = ref(null);
const remoteNames = ref([]);
const loadingNames = ref(false);
const loadingBonk = ref(false);

async function reloadNames() {
  loadingNames.value = true;
  remoteNames.value = await getBonknames();
  loadingNames.value = false;
}

async function doStartBonk(name) {
  document.title = `Bonk ${name}`;
  loadingBonk.value = true;
  const port = await startBonk(name);
  wsUrl.value = `wss://bonk.charge.re/ws/?remoteName=${name}&port=${port}`;
}

function stopLoading() {
  loadingBonk.value = false;
}

async function submitStartBonk() {
  if (remoteName.value === null) return;
  await doStartBonk(remoteName.value);
}

onMounted(async () => {
  document.title = 'Bonk';
  const urlRemoteName = route.params['urlRemoteName'] || null;
  if (urlRemoteName !== null) {
    remoteName.value = String(urlRemoteName);
    await doStartBonk(remoteName.value);
  }
  await reloadNames();
});

</script>

<style scoped>

</style>
